<template>
  <div id="create" class="mb-10 mt-10">
    <draw @interface="getChildInterface" :draw="data"></draw>
    <div id="category_hits" class="my-10 text-h5 text-center">
      <h3>Category Hits</h3>
    </div>
    <category-views></category-views>
    <img :src="require('@/assets/google-analytics-logo.jpg')" alt="" />

    <v-card>
      <v-toolbar flat color="#1a73e8" dark>
        <v-toolbar-title
          >Blue Business Guide Website Performance</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <!-- <v-toolbar-title>Google Analytics</v-toolbar-title> -->
      </v-toolbar>
    </v-card>
    <google-analytics></google-analytics>
    <!-- <div style="height: 1000px">
      <iframe
        width="600"
        height="534"
        src="https://lookerstudio.google.com/embed/reporting/9e51e1f4-ef4f-4217-80b0-b58a0a4063bf/page/1M"
        frameborder="0"
        style="border:0"
        allowfullscreen
      ></iframe>
    </div> -->
    <v-speed-dial
      v-model="fab"
      :top="top"
      :bottom="bottom"
      :right="right"
      :left="left"
      :direction="direction"
      :open-on-hover="hover"
      :transition="transition"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="blue darken-2" dark fab>
          <v-icon v-if="fab">
            mdi-close
          </v-icon>
          <v-icon v-else>
            mdi-dialpad
          </v-icon>
        </v-btn>
      </template>

      <a :href="`${baseUrl}`" target="_blank"
        ><v-btn elevation="2" color="primary">Go to site</v-btn></a
      >
      <a :href="`${baseUrl}/browse/test-category/mill-park`" target="_blank"
        ><v-btn elevation="2" color="primary">Test Category</v-btn></a
      >
      <a href="#pricings"
        ><v-btn elevation="2" color="primary">Packages Pricing</v-btn></a
      >
      <a href="#category_hits"
        ><v-btn elevation="2" color="primary">View category hits</v-btn></a
      >
      <v-btn elevation="2" color="primary" @click="openTestimonialDialog"
        >Video Testimonials</v-btn
      >
      <v-btn
        elevation="2"
        :color="activeTool === 'pen' ? 'success' : 'primary'"
        @click="setTool('pen')"
        >Pen</v-btn
      >
      <v-btn
        elevation="2"
        :color="activeTool === 'eraser' ? 'warning' : 'primary'"
        @click="setTool('eraser')"
        >Eraser</v-btn
      >
    </v-speed-dial>

    <v-dialog v-model="testimonialDialog" max-width="900px">
      <v-card>
        <v-card-title class="headline">Video Testimonials</v-card-title>
        <v-card-text>
          <video
            ref="testimonialVideo"
            controls
            playsinline
            preload="metadata"
            style="width: 100%; border-radius: 8px"
          >
            <source :src="testimonialUrl" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <a :href="testimonialUrl" target="_blank">
            <v-btn text color="primary">Open in new tab</v-btn>
          </a>
          <v-btn text color="primary" @click="testimonialDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CategoryViews from '../user_views/CategoryViews'
import { Strings } from '../../../utils'
import Draw from './Draw.vue'
import GoogleAnalytics from './GoogleAnalytics.vue'
export default {
  props: ['data'],
  childInterface: {
    addCount: () => {}
  },
  data() {
    return {
      baseUrl: Strings.baseUrl,
      testimonialUrl: 'https://www.bluebusinessguide.com.au/testimonial.mp4',
      stagingUrl: Strings.staging,
      direction: 'top',
      fab: false,
      fling: false,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: 'slide-y-transition',
      testimonialDialog: false,
      activeTool: 'pen'
      // penEvent: 'source-over',
      // save: false,
    }
  },
  mounted() {},
  components: {
    CategoryViews,
    Draw,
    GoogleAnalytics
  },
  methods: {
    getChildInterface(childInterface) {
      this.$options.childInterface = childInterface
    },

    setTool(tool) {
      this.activeTool = tool === 'eraser' ? 'eraser' : 'pen'
      if (this.$options.childInterface.setTool) {
        this.$options.childInterface.setTool(this.activeTool)
      }
    },
    openTestimonialDialog() {
      this.fab = false
      this.testimonialDialog = true
    },
    save() {
      this.captureDrawing()
    },
    captureDrawing() {
      if (this.$options.childInterface.capture) {
        this.$options.childInterface.capture()
        return
      }
      if (this.$options.childInterface.save) {
        this.$options.childInterface.save()
      }
    },
    applyDummyDrawing(payload = {}) {
      if (this.$options.childInterface.applyDummyWriting) {
        this.$options.childInterface.applyDummyWriting({
          ...payload,
          captureAfter: true
        })
        return
      }
      if (this.$options.childInterface.capture) {
        this.$options.childInterface.capture()
      }
    },
    clearDrawing() {
      if (this.$options.childInterface.clear) {
        this.$options.childInterface.clear()
      }
    }
  },
  watch: {
    testimonialDialog(value) {
      if (!value && this.$refs.testimonialVideo) {
        this.$refs.testimonialVideo.pause()
        this.$refs.testimonialVideo.currentTime = 0
      }
    }
  }
}
</script>

<style scoped lang="scss">
#create .v-speed-dial {
  position: fixed;
  bottom: 8%;
  right: 12%;
}
.main-color {
  color: rgb(8, 125, 196);
}

.centered {
  display: flex;
  justify-content: center;
  border: 0.2rem solid rgb(8, 125, 196);
  a {
    text-decoration: none;
  }
  padding: 1rem;
}

.centered2 {
  position: fixed;
  bottom: 5%;
  right: 5%;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 999999;
  a {
    text-decoration: none;
    margin-bottom: 1rem;
  }
  padding: 1rem 2rem;
}
iframe {
  aspect-ratio: 3/4;
  height: 100%;
  width: 100%;
}
img {
  width: 220px;
}
</style>
